import { Component, inject, OnInit } from '@angular/core';
import { EventSystemHeadlineComponent } from "../../headline/feature/headline.component";
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { EventSystemActions } from '../../../data-services/stores/actions/event-system.actions';
import { selectEventSystem } from '../../../data-services/stores/selectors/event-systems.selectors';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-event-system-terms',
  imports: [EventSystemHeadlineComponent, AsyncPipe],
  templateUrl: '../ui/terms.component.html',
  styleUrls: ['../ui/terms.component.css']
})
export class EventSystemTermsComponent {
  private readonly _store = inject(Store);
  private readonly _activatedRoute = inject(ActivatedRoute);
  eventSystem$ = this._store.select(selectEventSystem(this._activatedRoute.snapshot.params["id"]))

  constructor() {
    this._store.dispatch(EventSystemActions.getSingleEventSystem({ systemRef: this._activatedRoute.snapshot.params["id"] }))
  }

}
